import { useMemo } from "react";
import { formatDateUTCToTimeLocal } from "@utils/datetime";
import { Tooltip } from "@components/index";
import styles from "./ExecutionEventLogLine.module.scss";

const EXECUTION_EVENT_LABELS: Record<Sentinel.Enumerators.ProcessExecutionEventType, string> = {
  START: "Início da rodada",
  ERROR: "Erro da rodada",
  RESTART: "Reinício da rodada",
  FINISH: "Final da rodada",
  UNDEFINED: "",
};

interface ExecutionEventLogLineProps {
  event: Sentinel.Timeline.ExecutionEvent;
}
const ExecutionEventLogLine = ({ event }: ExecutionEventLogLineProps) => {
  const { executionTime, eventType, message = "" } = event;

  const formattedTime = useMemo(
    () => formatDateUTCToTimeLocal(executionTime, "--:--"),
    [executionTime]
  );

  const displayText = useMemo(() => {
    if (message) {
      return message;
    }

    if (eventType && eventType in EXECUTION_EVENT_LABELS) {
      return EXECUTION_EVENT_LABELS[eventType];
    }

    return "";
  }, [message, eventType]);

  const shouldRender = useMemo(
    () => Boolean(displayText || executionTime),
    [displayText, executionTime]
  );

  if (!shouldRender) {
    return <></>;
  }

  return (
    <Tooltip description={displayText || "--"} position="top" showArrow>
      <div className={styles["log-line"]}>
        <span className={styles["log-line-text"]}>
          {displayText || "--"}
        </span>
        <span className={styles["log-line-time"]}>{formattedTime}</span>
      </div >
    </Tooltip>
  );
};

export default ExecutionEventLogLine;
